// Book orbs — click each to wash the Crisis section in that book's palette.
// Uses @paper-design/shaders (mesh gradient) since we already have it; not
// worth rewriting in custom GLSL for what's effectively a click-toy.

import { ShaderMount, meshGradientFragmentShader, getShaderColorFromString } from '@paper-design/shaders';

const BOOKS: Record<string, string[]> = {
  lotr: ['#120300', '#7A1E08', '#E84E1B', '#FFB347', '#FFE89E'],
  odyssey: ['#001818', '#055a5a', '#16b4b4', '#5DFBE9', '#C9F8EC'],
  wrong: ['#020F05', '#1B5D1F', '#3ED23E', '#8EF78E', '#DFFBDF'],
  silmarillion: ['#000518', '#0B2E7A', '#2C70E8', '#7FC1FF', '#D5EBFF'],
};

export function initBookOrbs(): void {
  const crisisShader = document.getElementById('crisisShader');
  if (!crisisShader) return;

  let mount: any = null;
  let hideTimer: any = null;
  let fadeTimer: any = null;

  function show(bookKey: string) {
    const colorStrings = BOOKS[bookKey];
    if (!colorStrings) return;
    const palette = colorStrings.map(getShaderColorFromString);

    clearTimeout(hideTimer);
    clearTimeout(fadeTimer);

    if (!mount) {
      mount = new ShaderMount(
        crisisShader as HTMLElement,
        meshGradientFragmentShader,
        {
          u_colors: palette,
          u_colorsCount: palette.length,
          u_distortion: 0.95,
          u_swirl: 0.8,
          u_grainMixer: 0.12,
          u_grainOverlay: 0.04,
          u_scale: 1.5,
          u_rotation: 0,
          u_offsetX: 0,
          u_offsetY: 0,
          u_originX: 0.5,
          u_originY: 0.5,
          u_worldWidth: 0,
          u_worldHeight: 0,
          u_fit: 2,
        },
        undefined,
        0.42
      );
    } else {
      mount.setUniforms({ u_colors: palette, u_colorsCount: palette.length });
      mount.setSpeed(0.42);
    }

    requestAnimationFrame(() => crisisShader!.classList.add('active'));

    hideTimer = setTimeout(() => {
      crisisShader!.classList.remove('active');
      fadeTimer = setTimeout(() => {
        if (mount) mount.setSpeed(0);
      }, 1300);
    }, 4500);
  }

  function trigger(orb: HTMLElement) {
    const book = orb.dataset.book;
    if (!book) return;
    orb.classList.remove('flash');
    void orb.offsetWidth;
    orb.classList.add('flash');
    show(book);
  }

  document.querySelectorAll<HTMLElement>('.orb[data-book]').forEach((orb) => {
    orb.addEventListener('click', () => trigger(orb));
    orb.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger(orb);
      }
    });
  });
}
